import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, withKeys as _withKeys, normalizeClass as _normalizeClass, createVNode as _createVNode, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8ebe7ec0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tw-relative tw-flex-1 tw-z-1" }
const _hoisted_2 = { class: "hover-modal" }

import { Ref, ref, onUnmounted } from "vue";
import ModalHoverSearchAssessment from "@/components/assessment/modalHoverSearchAssessment.vue";
import store from "@/store";
import { SEARCH_TYPE_ID } from "@/utils/constants";
import BaseSearchbox from "../common/form/baseSearchbox.vue";
import { getComponentUiText } from "@/utils/utilities";
import { debounce } from "lodash";


export default /*#__PURE__*/_defineComponent({
  __name: 'vendorAssessmentSearchBox',
  props: {
  initialValueSearch: {
    type: String,
    required: true,
  },
  hintText: {
    type: String,
    required: true,
  },
  idSearchBoxWrap: {
    type: String,
    required: false,
    default: "",
  },
  idInputSearch: {
    type: String,
    required: false,
    default: "",
  },
},
  emits: ["update:modelValue"],
  setup(__props, { emit }) {

const props = __props;





const modelValue: Ref<string> = ref("");
const lastValueSearch = ref("");
let valueSearch = "";

const currentValueSearch = debounce((value: any) => {
  modelValue.value = value;
  updateRecentSearch();
}, 550);

const recentSearchStateUpdate = (value: any) => {
  modelValue.value = value;
  emit("update:modelValue", modelValue.value);
};

const isInputFocused = ref(false);

const onInputFocus = (isFocus = true) => {
  valueSearch = modelValue.value;
  isInputFocused.value = isFocus;
};

const onblur = () => {
  setTimeout(() => {
    onInputFocus(false);
  }, 300);

  if (modelValue.value && modelValue.value !== lastValueSearch.value) {
    updateRecentSearch();
  }
};

const updateRecentSearch = async () => {
  if (valueSearch === modelValue.value) return;

  lastValueSearch.value = modelValue.value;
  emit("update:modelValue", modelValue.value);
  await store.commit("Vendor/SET_RECENT_SEARCH", modelValue.value);
};

onUnmounted(() => {
  window.removeEventListener("click", () => {});
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(BaseSearchbox, {
      id: __props.idSearchBoxWrap,
      class: _normalizeClass([
        'tw-relative tw-h-[44px] tw-rounded-[6px] tw-border tw-border-solid tw-border-[#EFF0F1] tw-bg-[#ffffff] tw-pt-[10px] tw-pb-[8px] tw-px-[15px]',
      ]),
      "model-value": modelValue.value,
      placeholder: _unref(getComponentUiText)('app-header-search-prompt-1'),
      "input-search": __props.idInputSearch,
      "onUpdate:modelValue": _unref(currentValueSearch),
      "onOn:focus": onInputFocus,
      "onOn:blur": onblur,
      onKeyup: _withKeys(updateRecentSearch, ["enter"])
    }, null, 8, ["id", "model-value", "placeholder", "input-search", "onUpdate:modelValue", "onKeyup"]),
    _withDirectives(_createElementVNode("div", _hoisted_2, [
      _createVNode(ModalHoverSearchAssessment, {
        "is-search-modal-assessment": false,
        "search-type-id": _unref(SEARCH_TYPE_ID).CL_INPUT,
        "is-vendor-assessment": true,
        onUpdateCurrentValueSearch: recentSearchStateUpdate
      }, null, 8, ["search-type-id"])
    ], 512), [
      [_vShow, isInputFocused.value]
    ])
  ]))
}
}

})